"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import BaseControl from "D5Utils/form_fields/BaseControl";

var AnyOfControl =
/*#__PURE__*/
function (_BaseControl) {
  _inherits(AnyOfControl, _BaseControl);

  function AnyOfControl(props) {
    var _this;

    _classCallCheck(this, AnyOfControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnyOfControl).call(this, props));
    _this.value = _this.validateValue(props.value);
    return _this;
  }

  _createClass(AnyOfControl, [{
    key: "validateValue",
    value: function validateValue(value) {
      return !Array.isArray(value) && value != null ? [value] : value;
    }
  }, {
    key: "_buildControlProps",
    value: function _buildControlProps() {
      var _this2 = this;

      var props = _objectSpread({
        searchEnabled: false,
        showClearButton: true,
        showSelectionControls: true,
        acceptCustomValue: true
      }, this.props, {
        dataSource: [],
        openOnFieldClick: false,
        // applyValueMode: 'useButtons',
        value: this.value,
        onValueChanged: function onValueChanged(e) {
          if (typeof _this2.props.onValueChanged === 'function') {
            _this2.props.onValueChanged(e);
          }
        }
      });

      return props;
    }
  }, {
    key: "instance",
    value: function instance() {
      return this.$_element.dxTagBox('instance');
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      this.value = this.validateValue(value);
      this.instance().option('value', this.value);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.$_element.dxTagBox('dispose');
      this.$_element.remove();
    }
  }, {
    key: "render",
    value: function render() {
      this.$_element = this.$_element.dxTagBox(_objectSpread({}, this._buildControlProps()));
    }
  }]);

  return AnyOfControl;
}(BaseControl);

export { AnyOfControl as default };